import React from 'react';
import Input from '../Input/input';
import { ssnFormatter, ssnLast4Formatter } from '../../../utils/formatters';

export class SsnInput extends React.Component {

  state = {
    value: '',
    formattedValue: ''
  };

  componentWillReceiveProps(newProps) {
    if (this.state.value !== newProps.input.value) {
      let formattedValue = newProps.htmlAttributes.disabled ? ssnLast4Formatter(newProps.input.value) : ssnFormatter(newProps.input.value, true);
      this.setState({ value: newProps.input.value, formattedValue: formattedValue });
    }
  }

  unmask = (unmasked, masked) => {
    const SSN_LENGTH = 9;
    let normalizeData = masked.replace(/[^\d*]/g, '').slice(0, SSN_LENGTH);
    let countOfMaskedChars = (masked.match(/\*/g) || []).length;
    let normalizedDataDigits = normalizeData.replace(/\*/g, '');

    return unmasked.slice(0, countOfMaskedChars) + normalizedDataDigits;
  };

  onChange = (event) => {
    event.persist();
    this.setState((prevState) => {
      let newValue = this.unmask(prevState.value, event.target.value);
      let newFormattedValue = ssnFormatter(newValue);
      return { value: newValue, formattedValue: newFormattedValue };
    }, () => {
      event.target.value = this.state.value;
      if (typeof this.props.input.onChange === 'function') {
        this.props.input.onChange(event);
      }
    });
  };

  onBlur = (event) => {
    this.setState((prevState) => {
      let newFormattedValue = ssnFormatter(prevState.value, true);
      return { formattedValue: newFormattedValue };
    });
    event.target.value = this.state.value;
    if (typeof this.props.input.onBlur === 'function') {
      this.props.input.onBlur(event);
    }
  };

  onSelect = (event) => {
    let valueLength = event.target.value.length;
    if ( event.target.selectionEnd !== valueLength) {
      event.target.setSelectionRange(valueLength, valueLength);
    }
  };

  render() {
    const { input, htmlAttributes, ...otherProps } = this.props;
    let inputCopy = Object.assign({}, input);
    inputCopy.onChange = this.onChange;
    inputCopy.onBlur = this.onBlur;
    inputCopy.value = this.state.formattedValue;
    htmlAttributes.onSelect = this.onSelect;
    return (<Input input={inputCopy} htmlAttributes={htmlAttributes} {...otherProps} />);
  }
}

export default SsnInput;
